export default __webpack_public_path__ + "static/media/endividamento.aa6d2501.svg";